import Ajax from '@/lib/ajax'
export default {
  addProductToPromotionActivity(
    id: string,
    input: {
      productId: string
      pictureUrl: string
      productName: string
      brandName: string
      productCode: string
      marketPrice: number
      price: number
      promotionPrice: number
      limit: number
      displayOrder: number
    }[]
  ) {
    return Ajax.post(`/api/MarketingManagement/promotionProduct/${id}`, input)
  },
  getList(
    pageSize: number,
    currentPage: number,
    promotionId?: string,
    brandName?: string,
    keyWord?: string
  ) {
    let params = {
      promotionId,
      keyWord,
      brandName,
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
    }
    return Ajax.get(`/api/MarketingManagement/promotionProduct`, {
      params: params,
    })
  },
}
